import { Button, Container, Grid2, TextField, Typography } from '@mui/material'
import 'assets/styles/sigIn.css'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useAuthStore } from 'context/AuthStore'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const INIT_DATA = {
  username: '',
  password: ''
}

const SignIn = () => {
  const { t } = useTranslation()
  const { authStore, authStoreFunc } = useAuthStore()
  const [data, setData] = useState(INIT_DATA)

  const handleChange = e => {
    const { name, value } = e.target
    setData(prevState => ({ ...prevState, [name]: value }))
  }

  const signIn = () => authStoreFunc.login(data)

  return (
    <form>
      <Container
        maxWidth="md"
        sx={{
          paddingTop: { lg: 24, xs: 12 }
        }}
      >
        <LoaderBackdrop loading={authStore.loading} />
        <Grid2
          container
          direction="column"
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          spacing={5}
        >
          <Grid2 size={{ xs: 10, md: 6 }}>
            <Typography
              variant="h5"
              align="center"
              sx={{
                fontWeight: 'medium',
                paddingBottom: 3,
                paddingTop: 1
              }}
            >
              {t('sigInPage.Authorization')}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 10, md: 6 }}>
            <TextField
              placeholder={t('sigInPage.username')}
              name="username"
              autoComplete="username"
              fullWidth
              onChange={handleChange}
            />
          </Grid2>

          <Grid2 size={{ xs: 10, md: 6 }}>
            <TextField
              placeholder={t('sigInPage.password')}
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              fullWidth
              onChange={handleChange}
            />
          </Grid2>

          <Grid2 size={{ xs: 10, md: 6 }}>
            <Button variant="contained" color="primary" fullWidth onClick={signIn}>
              Вход в систему
            </Button>
          </Grid2>
        </Grid2>
      </Container>
    </form>
  )
}

export default SignIn
